/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import axios from 'axios';
// import Modal from "react-responsive-modal";

import { toast } from 'react-toastify'; //토스트(toast)
import { confirmAlert } from 'react-confirm-alert'; //알럿창(alert confirm)
import Barcode from 'react-barcode';
//import PerfectScrollbar from 'react-perfect-scrollbar';

import Slider from 'react-slick';

class Card extends Component {
  state = {
    slideIndex: 0,
    slidePlay: true,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;

    this._getCardList();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getCardList = async () => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._getCardListApi();
      const intReturn = result.data[0].intReturn;

      const cardList = result.data[0].listData;
      //console.log(cardList)
      if (intReturn === 0) {
        const remainCash = result.data[0].cash;
        if (this._isMounted) {
          this.setState({
            cardList,
            remainCash,
            winReg: false,
          });
        }
      }
    }
  };

  _getCardListApi = () => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + '/cardList', {
        params: {
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _onReg = () => {
    const { setCardListShow, setCardRegShow } = this.props;

    setCardListShow(false);
    setCardRegShow(true);
  };
  _onCardRegHide = () => {
    const { setCardListShow } = this.props;
    setCardListShow(false);
  };
  _cardStop = (cardNumber) => {
    const { setCardListShow } = this.props;
    setCardListShow(false);
    confirmAlert({
      title: '포인트카드 정지',
      message:
        '해당 카드를 정지 하시겠습니까? 정지된 카드는 온/오프라인에서 사용 할 수 없으며, 정지 해지가 불가합니다.',
      buttons: [
        {
          label: '카드 정지하기',
          onClick: () => {
            this._onCardStop(cardNumber);
          },
        },

        {
          label: '취소',
          onClick: () => {
            setCardListShow(true);
          },
        },
      ],
    });
  };
  _onCardStop = async (cardNumber) => {
    const { setCardListShow, loginId } = this.props;
    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._onCardStopApi(cardNumber);
      if (result) {
        const intReturn = result.data[0].intReturn;

        if (intReturn === 0) {
          toast.success('정상적으로 카드가 정지 처리 되었습니다.');
          setCardListShow(true);
        } else {
          toast.error(
            '카드 정지 처리중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.'
          );
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };

  _onCardStopApi = (cardNumber) => {
    const { apiUrl, loginId, history } = this.props;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    return axios
      .post(
        apiUrl + '/cardStop',
        {
          params: {
            userid: loginId,
            cardNumber: cardNumber,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(cardNumber);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async (cardNumber) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    const rt = localStorage.getItem('rt');

    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      this._onCardStop(cardNumber);
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };

  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _onNext = () => {
    this.slider.slickNext();
  };
  _onPrev = () => {
    this.slider.slickPrev();
  };
  _onGoto = (i) => {
    ////console.log(i)
    this.slider.slickGoTo(i);
  };
  _CommaFormatted = (str) => {
    ////console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  _renderItem = () => {
    const { cardList, remainCash } = this.state;

    const list = cardList.map((item, index) => {
      return (
        <div className="cashcard_barcode_group" key={index}>
          <div className="cashcard_barcode_group_top"></div>
          <div className="cashcard_box">
            <h1 style={{ fontSize: 32 }}>
              총 {this._CommaFormatted(remainCash)}포인트
              <span>{item.cardName}</span>
            </h1>
            <div
              className="cashcard_box_barcode"
              style={{ textAlign: 'center' }}
            >
              <Barcode
                value={item.cardNumber}
                displayValue={false}
                height={35}
                format="CODE128"
                fontSize={9}
                margin={2}
                textMargin={1}
                width={2}
              />
              <span>
                {item.cardNumber.substr(0, 4)} {item.cardNumber.substr(4, 4)}{' '}
                {item.cardNumber.substr(8, 4)} {item.cardNumber.substr(12, 3)}
              </span>
            </div>
          </div>
          <div className="cashcard_box_foot">
            {/*<span>포인트카드 상태</span>*/}
            <div>
              {item.active ? (
                <a
                  style={{ cursor: 'pointer' }}
                  className="btn_a"
                  onClick={() => this._cardStop(item.cardNumber)}
                >
                  포인트카드 정지하기
                </a>
              ) : (
                <a>사용정지 됨</a>
              )}

              {/*item.active ? (
                                <Fragment>
                                <span style={{ display: 'block', color: '#ffffff', fontFamily:'GmarketSansBold', fontWeight: 'bold', fontSize: 24}}>사용중</span>
                                <p style={{cursor: 'pointer', color: '#ff5d24', fontFamily:'GmarketSansBold', fontWeight: 'bold', fontSize: 14}} onClick={()=>this._cardStop(item.cardNumber)}>[정지하기 X]</p>
                                </Fragment>
                            ) : (
                                <span style={{ display: 'block', color: '#ff5d24', fontFamily:'GmarketSansBold', fontWeight: 'bold', fontSize: 24}}>사용불가</span>
                            ) */}
            </div>
          </div>
        </div>

        /*
                <li style={{overflow: 'hidden', textAlign: 'center', paddingTop: 10}} key={index}>
                    <div>
                        <div style={{ position: 'relative', top: 25}}>
                            <span style={{color: '#ffffff', fontSize: 11}}>{item.cardName}</span>
                        </div>
                        <img src="/img/cashcard/cashcard01@2x.png"/>
                        
                        <div style={{position: 'relative', bottom: 55}}>
                            <Barcode 
                                value={item.cardNumber}
                                displayValue={false}
                                height={30}
                                format="CODE128"  
                                fontSize={9}
                                margin={2}
                                textMargin={1}
                                width={2}
                            />
                        </div>
                        <div  style={{position: 'relative', bottom: 53}}>
                            <span style={{color: '#ffffff', fontSize: 10}}>{item.cardNumber.substr(0, 4)} {item.cardNumber.substr(4, 4)} {item.cardNumber.substr(8, 4)} {item.cardNumber.substr(12, 3)}</span>
                        </div>
                        <div style={{position: 'relative', bottom: 45}}>
                            {item.active ? (
                                <span style={{ color: '#ffffff', cursor: 'pointer'}} onClick={()=>this._cardStop(item.cardNumber)}>사용 정지하기</span>
                            ) : (
                                <span style={{ color: 'red', cursor: 'pointer', fontWeight: '600'}}>사용 정지됨</span>
                            ) }
                            
                        </div>    
                    </div>
                </li>
                */
      );
    });

    return list;
  };
  render() {
    const { cardList } = this.state;
    const { imgUrl } = this.props;
    var settings = {
      dots: false,
      //dotsClass: "slick-dots slick-thumb",
      infinite: true,
      //speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      autoplay: true,
      //speed: 3000,
      //className: 'slide_baner baner_group baner_div1',
      pauseOnFocus: true,
      //fade: true,
      adaptiveHeight: false,
      //centerMode: true,

      //variableWidth: true,
      beforeChange: (current, next) => this.setState({ slideIndex: next }),
    };
    return (
      <Fragment>
        <div className="cashcard_pop">
          <div className="cashcard_pop_layer3">
            <div className="cashcard_close2">
              <a style={{ cursor: 'pointer' }} onClick={this._onCardRegHide}>
                닫기
              </a>
            </div>
            <Slider ref={(ref) => (this.slider = ref)} {...settings}>
              {cardList ? (
                this._renderItem()
              ) : (
                <div className="cashcard_barcode_group">
                  <div className="cashcard_barcode_group_top"></div>
                  <div className="cashcard_box">
                    <h1>
                      카드없음<span>애니플러스 매장에 문의하세요.</span>
                    </h1>
                    <div className="cashcard_box_barcode">
                      <img src={imgUrl + '/img/cashcard/barcode.jpeg'} />
                      <span>XXXX-XXXX-XXXX-XXX</span>
                    </div>
                  </div>
                  <div className="cashcard_box_foot">
                    {/*
                                    <span>현재 남은 포인트</span>
                                    <div>85,200 포인트</div>
                                    */}
                  </div>
                </div>
              )}
            </Slider>
            {/*<a style={{cursor: 'pointer'}} className="btn_a" onClick={this._onReg}>포인트카드 등록하기</a>*/}
          </div>
        </div>

        {/*
                <div className="cashcard_pop" style={{zIndex: 1000}}>
        
                    <div className="cashcard_pop_layer4" >
                        <div className="cashcard_close2"><a style={{ cursor: 'pointer', zIndex: 1100 }} onClick = {this._onCardRegHide}>닫기</a></div>
                        <PerfectScrollbar>
                        <div className="cashcard_pop_card">
                            
                            <h1><img src="/img/cashcard/logo_img.png"/>나의 포인트 카드</h1>
                            
                           
                            <ul className="radius2">
                                { cardList ? this._renderItem() : <li style={{ textAlign: 'center', color: '#ffffff'}}>등록된 카드가 없습니다.</li> }
                               
                            </ul>
                           
                            
                            <div className="cashcard_pop_line"></div>
                        </div>
                        </PerfectScrollbar>
                        <a style={{ cursor: 'pointer'}} onClick={this._onReg} className="btn_a">포인트카드 등록하기</a>
                    </div>

                </div>
                */}

        {/*
                <div style={{color: '#ffffff', paddingTop: 200}}>
                    <div>
                        <span onClick={this._onWinOpen}>카드 등록</span>
                    </div>
                    <div>
                        <span>나의 포인트 카드 목록.</span>
                        { cardList ? this._renderItem() : '등록된 카드가 없습니다.' }
                    </div>
                   
                    <div style={{ marginTop: 50, color: '#ffffff', width: 300, height: 200, textAlign: 'center'}} >
                        <span>미등록 선불카드 테스트</span>
                        <div>3232-2581-9632-1478</div>
                        <div>
                                <Barcode 
                                    value={'3232258196321478'}
                                    displayValue={true}
                                    height={30}
                                    format="CODE128"  
                                    fontSize={10}
                                    margin={2}
                                    textMargin={1}
                                    width={1.2}
                                />
                        </div>
                    </div>


                    <div style={{ marginTop: 50, color: '#ffffff', width: 300, height: 200, textAlign: 'center'}} >
                        <span>미등록 선불카드 테스트</span>
                        <div>9900-1234-5678-952</div>
                        <div>
                                <Barcode 
                                    value={'990012345678952'}
                                    displayValue={true}
                                    height={30}
                                    format="CODE128"  
                                    fontSize={10}
                                    margin={2}
                                    textMargin={1}
                                    width={1.2}
                                />
                        </div>
                    </div>
                   
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Card));
